import {useIntl} from 'react-intl'
import {Button, ButtonConfirmProgress} from '../../../../../gori/widgets'
import {useCallback, useState} from 'react'
import {CreateAllLabelsModal} from '../modals'

type CreateLabelButtonProps = {
  orderIds?: number[]
  batchId: number
  onSuccessCallback?: () => void
  isCreateAllLabels?: boolean
  onErrorCallback?: (error: any) => void
}
export const CreateLabelButton = ({
  batchId,
  orderIds = [],
  onSuccessCallback,
  isCreateAllLabels = false,
}: CreateLabelButtonProps) => {
  const intl = useIntl()

  const [showModal, setShowModal] = useState(false)

  const handleClose = useCallback(() => {
    setShowModal(false)
    onSuccessCallback?.()
  }, [onSuccessCallback])

  return (
    <>
      {isCreateAllLabels ? (
        <ButtonConfirmProgress
          className='btn text-white bg-image-gori user-select-none'
          label={intl.formatMessage({id: 'CREATE_ALL_LABELS'})}
          callBack={() => setShowModal(true)}
        />
      ) : (
        <Button
          className='btn btn-primary'
          label={intl.formatMessage({id: orderIds.length ? 'CREATE_LABELS' : 'CREATE_ALL_LABELS'})}
          event={() => setShowModal(true)}
        />
      )}

      {showModal && (
        <CreateAllLabelsModal
          batchId={batchId}
          show={showModal}
          orderIds={orderIds}
          handleClose={handleClose}
        />
      )}
    </>
  )
}
